import './GreekBorder.css';

// color — постоянный цвет рамки вместо цвета по состоянию партии (например,
// окна реплик Барбы в обучении всегда в основном цвете)
const GreekBorder = ({className, noBorder, color}) => {
  return null;
  /*
  const isGameStarted = useSelector(selectIsGameStarted);
  const gameType = useSelector(selectGameType);
  const userId = useSelector(selectUserId);
  const players = useSelector(selectPlayers);
  const gameResults = useSelector(selectGameResults);
  const currentPlayer = useSelector(selectCurrentPlayer);
  // Ходящий игрок, но в режиме планирования строительства — сам игрок
  // (см. getTurnColorPlayer)
  const colorPlayer = useSelector(getTurnColorPlayer);
  const phase = useSelector(selectPhase);

  const actingPlayer = getActingPlayer(gameType, userId, players, currentPlayer);

  let backgroundColor
  if (color) {
    backgroundColor = color
  } else if (!isGameStarted) {
    backgroundColor = CONTROLS_COLOR
  } else if (gameResults) {
    backgroundColor = PRIMARY_COLOR
  } else if (phase === PHASES.SETUP) {
    backgroundColor = getPlayerHexColor(actingPlayer.color)
  } else {
    backgroundColor = getPlayerHexColor(colorPlayer && colorPlayer.color);
  }

  return (
    <div
      className={`greek-boarder greek-boarder-current-player ${addClassNameIfTrue(noBorder, 'greek-boarder_border-none')} ${className}`}
      style={{
        backgroundColor,
        opacity: 0.9,
      }}
    />
  );*/
};

export default GreekBorder;

